<template>
  <div class="info_form">
    <van-form ref="form">
      <div class="contain">
        <van-field
          name="name"
          label="姓名"
          placeholder="请输入姓名"
          maxlength="15"
          clearable
          v-model="form.fullName"
          :rules="rules.name"
        />
        <van-field
          readonly
          clickable
          right-icon="arrow"
          name="picker"
          label="性别"
          placeholder="请选择性别"
          @click="showPicker = true"
          :value="form.sexName"
          :rules="[{ required: true, trigger: 'onChange' }]"
        />
      </div>

      <div class="contain">
        <van-field
          name="手机号"
          label="手机号"
          type="number"
          maxlength="11"
          placeholder="请输入手机号"
          v-model="form.mobile"
          :rules="rules.mobile"
        />
        <van-field
          name="身份证号"
          label="身份证号"
          maxlength="18"
          placeholder="请输入身份证号"
          v-model="form.idCard"
          :rules="rules.idCard"
        />
        <van-field name="年龄" label="年龄" readonly :value="age" />
      </div>

      <van-field
        readonly
        clickable
        right-icon="arrow"
        @click="showCommittee = true"
        name="所属居委"
        label="所属居委"
        placeholder="请选择所属居委"
        :value="form.committeeName"
        :rules="[{ required: true, trigger: 'onChange' }]"
      />

      <van-field
        v-if="isFamily"
        right-icon="arrow"
        readonly
        clickable
        @click="showRelationship = true"
        name="与本人关系"
        label="与本人关系"
        placeholder="请选择与本人关系"
        v-model="form.myRelationName"
      />

      <van-button
        class="bot"
        :loading="loading.load"
        :class="{ done_bot: canSave }"
        style="margin: 16px;"
        @click="onSubmit"
      >
        保存
      </van-button>
    </van-form>

    <van-popup
      v-model="showPicker"
      round
      position="bottom"
      :style="{ height: '35%' }"
    >
      <div class="title">
        性别
      </div>
      <van-picker
        ref="sex"
        item-height="50"
        visible-item-count="2"
        :columns="columns"
      >
      </van-picker>
      <div class="bottom" style="margin: 16px;" @click="confirmSex">
        确定
      </div>
    </van-popup>
    <van-popup
      v-model="showRelationship"
      round
      position="bottom"
      :style="{ height: '55%' }"
    >
      <div class="title">
        与本人关系
      </div>
      <van-picker
        ref="relation"
        item-height="40"
        visible-item-count="5"
        :columns="relationshipSelect"
        value-key="dictLabel"
      >
      </van-picker>
      <div class="bottom" style="margin: 16px;" @click="confirmRalation">
        确定
      </div>
    </van-popup>
    <van-popup
      v-model="showCommittee"
      round
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="title">
        所属居委
      </div>
      <van-picker
        ref="committee"
        item-height="40"
        visible-item-count="4"
        :columns="committeeSelect"
      >
      </van-picker>
      <div class="bottom" style="margin: 16px;" @click="confirmCommittee">
        确定
      </div>
    </van-popup>
  </div>
</template>
<script>
import { areaCode } from "@/common/constants.js";
import { mapState } from "vuex";
import {
  getDistrictSelect,
  getRelationSelect,
  getPersonInfo,
  getUserInfoDetail,
} from "@/api/user.js";
import { GetAge } from "@/utils/dataDeelMethod.js";

export default {
  name: "infoForm",
  props: {
    isFamily: {
      default: false,
      type: Boolean,
    },
    isEdit: {
      default: false,
      type: Boolean,
    },
    info: {
      default: () => {
        return {};
      },
      type: Object,
    },
    personId: {
      default: "",
    },
  },
  data() {
    function validatorIdcard(val) {
      if (val) {
        return /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/.test(
          val
        );
      } else {
        return true;
      }
    }
    return {
      loading: {
        load: false,
      },

      showRelationship: false,
      showCommittee: false,
      showPicker: false,
      columns: ["男", "女"],
      form: {
        areaCode,
        fullName: "",
        sex: "",
        mobile: "",
        idCard: "",
        committeeName: "",
        sexName: "",
        myRelationName: "",
        myRelation: "",
      },
      committee: [],
      rules: {
        name: [{ required: true, trigger: "onBlur" }],
        mobile: [
          { required: true, trigger: "onBlur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "onBlur",
          },
        ],
        idCard: [
          { required: false, trigger: "onBlur" },
          {
            validator: validatorIdcard,
            message: "请输入正确的身份证号",
            trigger: "onBlur",
          },
        ],
      },
      relationshipSelect: [],
      show: false,
    };
  },
  methods: {
    async onSubmit() {
      if (!this.canSave) {
        return;
      }
      await this.$refs.form.validate();
      console.log("提交时候的form", this.form);
      delete this.form.params;
      this.$emit("submit-form", {
        ...this.form,
        openId: this.openId,
        loading: this.loading,
      });
    },
    confirmSex() {
      this.form.sexName = this.$refs.sex.getValues()[0];
      this.form.sex = this.$refs.sex.getValues()[0] === "男" ? "0" : "1";
      this.showPicker = false;
    },
    confirmCommittee() {
      this.form.committeeName = this.$refs.committee.getValues()[0];
      this.committee.forEach((item) => {
        if (item.screenConfigKey === this.$refs.committee.getValues()[0]) {
          this.form.areaCode = item.screenConfigValue;
        }
      });
      this.showCommittee = false;
    },
    confirmRalation() {
      this.form.myRelationName = this.$refs.relation.getValues()[0].dictLabel;
      this.form.myRelation = this.$refs.relation.getValues()[0].dictValue;
      console.log(this.form);
      this.showRelationship = false;
    },
    // 获取数据字典内容
    async getDictionary() {
      const { data } = await getDistrictSelect({
        screenConfigType: "通用",
        screenName: "南京东路街道大屏",
      });
      this.committee = data;
    },
    // 获取与本人关系下拉框数据
    async getRelationSelect() {
      let res = await getRelationSelect({ dictTypes: "my_relation " });
      this.relationshipSelect = res.my_relation;
    },
    // 拿回显数据
    async getData() {
      if (this.personId === "") {
        // 编辑本人，没有传personId
        const { data } = await getUserInfoDetail(this.openId);
        this.info = data;
      } else {
        const { data } = await getPersonInfo(this.personId);
        this.info = data;
      }
    },
  },
  computed: {
    ...mapState("user", ["openId"]),
    age() {
      return isNaN(GetAge(this.form.idCard)) ? "" : GetAge(this.form.idCard);
    },
    canSave() {
      return this.isFamily
        ? this.form.fullName &&
            this.form.sex &&
            this.form.mobile &&
            // this.form.idCard &&
            this.form.committeeName &&
            this.form.myRelation
        : this.form.fullName &&
            this.form.sex &&
            this.form.mobile &&
            // this.form.idCard &&
            this.form.committeeName;
    },
    committeeSelect() {
      return this.committee.map((item) => item.screenConfigKey);
    },
  },
  async mounted() {
    if (this.isEdit) {
      await this.getData();
    }
    await this.getDictionary();
    await this.getRelationSelect();
    if (this.isEdit) {
      let committeeName = "";

      this.committee.forEach((item) => {
        if (item.screenConfigValue === this.info.areaCode) {
          committeeName = item.screenConfigKey;
        }
      });
      if (this.info.myRelation) {
        let myRelationObj = this.relationshipSelect.find(
          (item) => item.dictValue == this.info.myRelation
        );
        this.info.myRelationName = myRelationObj ? myRelationObj.dictLabel : "";
      }
      this.form = {
        ...this.info,
        committeeName,
        sexName: this.info.sex === "1" ? "女" : "男",
      };
      console.log("回显时候的form", this.form);
    }
  },
};
</script>

<style lang="scss" scoped>
.info_form {
  .van-form {
    .contain {
      border-bottom: 8px solid #fff8e9;
    }

    .van-field {
      padding-left: 36px;
      ::v-deep {
        .van-cell__title {
          span {
            position: relative;
            width: 46px;
            height: 22px;
            opacity: 1;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            text-align: left;
            color: #543302;
            &::before {
              position: absolute;
              right: -15px;
              top: 0;
              color: #ee0a24;
              font-size: 0.37333rem;
              content: "*";
            }
          }
        }
      }
    }
    .contain:nth-child(2) {
      .van-field:nth-child(2),
      .van-field:nth-child(3) {
        ::v-deep {
          .van-cell__title {
            span {
              &::before {
                content: "";
              }
            }
          }
        }
      }
    }
  }
  .van-popup {
    .title {
      margin: 0 auto;
      width: 304px;
      height: 61px;
      opacity: 1;
      font-size: 20px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      text-align: center;
      color: #000000;
      line-height: 61px;
      border-bottom: 1px solid #707070;
    }
  }
  .bot {
    position: absolute;
    bottom: 0;
    z-index: 999;
    width: 100%;
    margin: 0 !important;
    width: 375px;
    height: 49px;
    opacity: 1;
    background: #ffedbb;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    text-align: center;
    color: #543302;
    line-height: 49px;
    font-size: 18px;
  }
  .done_bot {
    background-color: #ffd63c;
  }
  .bottom {
    position: absolute;
    bottom: 0;
    z-index: 999;
    width: 100%;
    margin: 0 !important;
    width: 375px;
    height: 49px;
    opacity: 1;
    background: #ffd63c;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 700;
    text-align: center;
    color: #543302;
    line-height: 49px;
    font-size: 18px;
  }
  .van-number-keyboard {
    z-index: 99999;
  }
}
</style>
